import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/connect.js';
import q from '../query.js';
export const connectConnectionsEntity = 'connect-connections';
export const connectMappingsEntity = 'connect-mappings';
export const connectProductsEntity = 'connect-products';
export const connectInvitationsEntity = 'connect-invitations';
const connectProductsKey = `connect-products`;
export const useConnectProducts = () => q.query(connectProductsKey, api.products, keys.read.collection(connectProductsEntity));
const connectInvitationsKey = `connect-invitations`;
export const useConnectInvitations = () => q.query(connectInvitationsKey, api.invitations, keys.read.collection(connectInvitationsEntity));
const connectInvitationKey = (id) => `connect-invitations-${id}`;
export const useConnectInvitation = (id, token) => q.query(connectInvitationKey(id), () => api.invitationById(id, token), keys.read.item(connectInvitationsEntity, id), {
    enabled: id != null && token != null,
});
const connectConnectionsFromKey = `connect-connections-from`;
export const useConnectConnectionsFrom = () => q.query(connectConnectionsFromKey, api.connectionsFrom, keys.read.collection(connectConnectionsEntity));
const connectConnectionsKey = `connect-connections`;
export const useConnectConnections = () => q.query(connectConnectionsKey, api.connections, keys.read.collection(connectConnectionsEntity));
const connectMappingEntityMappingsKey = (caseId) => `cases-${caseId}-connect-entity-mappings`;
export const useConnectMappingEntityMappings = (caseId, options = {}) => q.query(connectMappingEntityMappingsKey(caseId), () => api.getEntityMappings(caseId).then((res) => {
    const lookup = {};
    for (const mapping of res) {
        const fromThisTenant = mapping.originCaseId === caseId;
        for (const entityMapping of mapping.entityMappings) {
            if ((fromThisTenant && entityMapping.source === 'CREATED') ||
                (!fromThisTenant && entityMapping.source === 'ORIGIN')) {
                const id = fromThisTenant
                    ? entityMapping.createdEntityId
                    : entityMapping.originEntityId;
                lookup[id] = {
                    connectionId: entityMapping.connectConnectionId,
                };
            }
        }
    }
    return lookup;
}), keys.read.collection(connectMappingsEntity), {
    enabled: (options.enabled ?? true) ? caseId != null : false,
});
export const connectCaseMappingOnCaseKey = (caseId) => `connect-case-mappings-on-case-${caseId}`;
export const useConnectCaseMappingOnCase = (caseId, options = {}) => q.query(connectCaseMappingOnCaseKey(caseId), () => api.getCaseMappingsOnCase(caseId), keys.read.collection(connectMappingsEntity), {
    enabled: (options.enabled ?? true) ? caseId != null : false,
});
const connectConnectionKey = (id) => `connect-connections-${id}`;
export const useConnectConnection = (id) => q.query(connectConnectionKey(id), () => api.connectionsById(id), keys.read.item(connectConnectionsEntity, id), {
    enabled: !!id,
});
export const connectProductKey = (id) => `connect-products-${id}`;
export const useConnectProduct = (id) => q.query(connectProductKey(id), () => api.productsById(id), keys.read.item(connectProductsEntity, id), {
    enabled: !!id,
});
const connectCaseMappingKey = (id) => `connect-case-mappings-${id}`;
export const useConnectCaseMapping = (id) => q.query(connectCaseMappingKey(id), () => api.getCaseMapping(id), keys.read.item(connectMappingsEntity, id));
export const connectCaseMappingsOnConnectionKey = (connectionId) => `connect-case-mappings-on-connection-${connectionId}`;
export const useConnectCaseMappingOnConnection = (connectionId) => q.query(connectCaseMappingsOnConnectionKey(connectionId), () => api.getCaseMappingsOnConnection(connectionId), keys.read.collection(connectMappingsEntity));
//# sourceMappingURL=index.js.map